import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, dark = false }) => (
  <p
    className={`font-mono text-[11px] tracking-[0.35em] ${
      dark ? "text-ink/60" : "text-lime"
    }`}
  >
    {children}
  </p>
);

export const SectionHead = ({ eyebrow, children, dark = false, center = false }) => (
  <Reveal className={`mb-10 sm:mb-14 ${center ? "text-center" : ""}`}>
    <Eyebrow dark={dark}>{eyebrow}</Eyebrow>
    <h2
      className={`mt-4 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.05] ${
        dark ? "text-ink" : "text-cream"
      }`}
    >
      {children}
    </h2>
  </Reveal>
);

export const Em = ({ children }) => (
  <em className="font-serif italic font-medium text-lime">{children}</em>
);
